import api from './app/api';

export const roundNumber = (num) => {
  return Math.ceil(num * 100) / 100;
}

export const createOption = (label, category) => ({
  id: '',
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
  category: category,
});

export const postApi = async (url, obj) => {
  const response = await api.post(
      url,
      obj
    );
    return response;
};